
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("h5X3Q"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("h5X3Q", function(module, exports) {

let $c720b78f5cdc7ae1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c720b78f5cdc7ae1$var$load("h3ABO"),
    $c720b78f5cdc7ae1$var$load("LVAZY"),
    $c720b78f5cdc7ae1$var$load("fSobj"),
    $c720b78f5cdc7ae1$var$load("74u2y"),
    $c720b78f5cdc7ae1$var$load("2YffH"),
    $c720b78f5cdc7ae1$var$load("1aTst"),
    $c720b78f5cdc7ae1$var$load("6mHrv"),
    $c720b78f5cdc7ae1$var$load("awWN9"),
    $c720b78f5cdc7ae1$var$load("9CYct"),
    $c720b78f5cdc7ae1$var$load("iIoyG"),
    $c720b78f5cdc7ae1$var$load("2xn4F"),
    $c720b78f5cdc7ae1$var$load("hZtKG"),
    $c720b78f5cdc7ae1$var$load("iNmaF"),
    $c720b78f5cdc7ae1$var$load("lVO3w"),
    $c720b78f5cdc7ae1$var$load("hyzoX"),
    $c720b78f5cdc7ae1$var$load("h9Ed7"),
    $c720b78f5cdc7ae1$var$load("eBRUf"),
    $c720b78f5cdc7ae1$var$load("b2zxR"),
    $c720b78f5cdc7ae1$var$load("tKhaz"),
    $c720b78f5cdc7ae1$var$load("bogQM"),
    $c720b78f5cdc7ae1$var$load("jq3Ai"),
    $c720b78f5cdc7ae1$var$load("cD6Zr"),
    $c720b78f5cdc7ae1$var$load("dtASV"),
    $c720b78f5cdc7ae1$var$load("8A3nE"),
    $c720b78f5cdc7ae1$var$load("8YSo7"),
    $c720b78f5cdc7ae1$var$load("g7ggm"),
    $c720b78f5cdc7ae1$var$load("Wowvf"),
    $c720b78f5cdc7ae1$var$load("gusn7"),
    $c720b78f5cdc7ae1$var$load("kiGNy"),
    $c720b78f5cdc7ae1$var$load("7do1E"),
    $c720b78f5cdc7ae1$var$load("77dkW"),
    $c720b78f5cdc7ae1$var$load("1MlIV"),
    $c720b78f5cdc7ae1$var$load("g9CVe"),
    $c720b78f5cdc7ae1$var$load("7oiUM"),
    $c720b78f5cdc7ae1$var$load("8t3po"),
    $c720b78f5cdc7ae1$var$load("855o0"),
    $c720b78f5cdc7ae1$var$load("8MfZE"),
    $c720b78f5cdc7ae1$var$load("hv4mn"),
    $c720b78f5cdc7ae1$var$load("dek7I"),
    $c720b78f5cdc7ae1$var$load("dYtBN"),
    $c720b78f5cdc7ae1$var$load("6wr18"),
    $c720b78f5cdc7ae1$var$load("kjZZD"),
    $c720b78f5cdc7ae1$var$load("8iA2F"),
    $c720b78f5cdc7ae1$var$load("4RhJO"),
    $c720b78f5cdc7ae1$var$load("iif0M"),
    $c720b78f5cdc7ae1$var$load("2cMKQ"),
    $c720b78f5cdc7ae1$var$load("ffEVr"),
    $c720b78f5cdc7ae1$var$load("dRpV3"),
    $c720b78f5cdc7ae1$var$load("dTsOE"),
    $c720b78f5cdc7ae1$var$load("hhss7"),
    $c720b78f5cdc7ae1$var$load("kknel"),
    $c720b78f5cdc7ae1$var$load("oTvoe"),
    $c720b78f5cdc7ae1$var$load("6u1hm"),
    $c720b78f5cdc7ae1$var$load("8fMw3"),
    $c720b78f5cdc7ae1$var$load("hogcU"),
    $c720b78f5cdc7ae1$var$load("dAdaw"),
    $c720b78f5cdc7ae1$var$load("j47Y5"),
    $c720b78f5cdc7ae1$var$load("ivqr8"),
    $c720b78f5cdc7ae1$var$load("7EorR"),
    $c720b78f5cdc7ae1$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.3413f747.js.map
